import {
  signInWithPopup,
  GoogleAuthProvider,
  signOut,
  signInWithEmailAndPassword,
  createUserWithEmailAndPassword,
} from "firebase/auth";
import { auth } from "../firebase/firebaseConfig";

export const mapFirebaseUserToAppUser = (user) => ({
  id: user.uid,
  name: user.displayName,
  email: user.email,
  photoUrl: user.photoURL,
});


export const getCurrentUser = () => {
  const user = auth.currentUser;

  if (!user) {
    throw new Error("No user is currently signed in.");
  }

  return mapFirebaseUserToAppUser(user);
};

export const signInWithGoogleService = async () => {
  const provider = new GoogleAuthProvider();

  try {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    return mapFirebaseUserToAppUser(user);
  } catch (error) {
    console.error("Error signing in with Google: ", error);
    throw error;
  }
}

export const signInWithEmailService = async (email, password) => {
  try {
    const { user } = await signInWithEmailAndPassword(auth, email, password);
    return mapFirebaseUserToAppUser(user);
  } catch (error) {
    console.error("Error signing in with email and password: ", error);
    throw error;
  }
};

export const signUpWithEmailService = async (email, password) => {
  try {
    const { user } = await createUserWithEmailAndPassword(auth, email, password);
    return mapFirebaseUserToAppUser(user);
  } catch (error) {
    console.error("Error creating account with email and password: ", error);
    throw error;
  }
};

// Sign Out user
export const signOutUser = async () => {
  try {
    await signOut(auth);
    return null;
  } catch (error) {
    console.error("Error signing out: ", error);
    throw error;
  }
};

